import React, { Component } from "react";
import Footer from "../Components/Footer.js";
import HomeNavbar from "../HomeNavbar.js";
import StatsBox from "../Components/StatsPage/StatsBox.js";
import ResultInfoText from "../Components/ResultsTable/ResultInfoText.js";
import { useState, useEffect } from "react";
import axios from "../api/axios.js";
import SmallLoading from "../Components/smallLoading.js";
import { persistentIdToCsv, historicNoteToCSV } from "../functions/MiscDataToCSV.js";
import dataToCsv from "../functions/searchResultToCSV.js";
import mechanismDataToCsv from "../functions/mechanismDataToCSV.js";
import InfoTable from "../Components/InfoTable.js";
import JSZip from "jszip";
import DownloadButton from "../Components/DownloadPgae/DownloadButton.js";
import useAuth from "../hooks/useAuth.js";
import { submissionToCsv } from "../functions/searchResultToCSV.js";
import Dagre from '@dagrejs/dagre';
import Tooltip from "../Components/Tooltip.js";
import ExternalLink from "../Components/ReactionTable/externalLink.js";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";


function DownloadPage() {
  const [downloadData, setDownloadData] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [structureMethods, setStructureMethods] = useState([]); // Nový stav
  const [structureSources, setStructureSources] = useState([]);
  const [selectedSource, setSelectedSource] = useState(""); // "" = all sets
  const editor = [1984, 5150];
  const { auth } = useAuth();

  const [olderVersions, setOlderVersions] = useState([]);
  const [isLoadingOlder, setIsLoadingOlder] = useState(true);
  const [showAllVersions, setShowAllVersions] = useState(false);

  async function fetchDownloads() {
    try {
      const response = await axios.post("/download", {stats: true});
      setDownloadData(response.data);
      // const methodsResp = await axios.get("/structuremethods");
      // setStructureMethods(methodsResp.data?.methods || []);
      const sourcesResp = await axios.get("/structuresources");
      setStructureSources(sourcesResp.data?.sources || []);
    } catch (err) {
      console.error("Failed to fetch initial download data:", err);
    }
  }

  async function fetchOlderVersions() {
    setIsLoadingOlder(true);

    const root = (process.env.PUBLIC_URL || "");
    const manifestUrl = `${root}/downloadVersions/manifest.json`;

    // 1) Try manifest.json (recommended)
    try {
      const r = await fetch(manifestUrl, { credentials: "same-origin" });
      console.log("Fetched manifest.json:", r);
      if (r.ok) {
        console.log("Manifest response OK");
        const arr = await r.json();
        console.log("Parsed manifest.json:", arr);
        if (Array.isArray(arr)) {
          setOlderVersions(
            arr
              .filter(it => typeof it?.url === "string" && it.url.toLowerCase().endsWith(".zip"))
              .map(it => ({
                name: it.name || it.url.split("/").pop(),
                url: it.url.startsWith("http")
                  ? it.url
                  : `${root}${it.url.startsWith("/") ? "" : "/"}${it.url}`
              }))
          );
          setIsLoadingOlder(false);
          return;
        }
      }
    } catch (_) {
      console.warn(_);
      // fall through to HTML parsing
    }

    setIsLoadingOlder(false);
  }

  useEffect(() => {
          fetchDownloads();
          fetchOlderVersions();
        }, []);


    if (!downloadData) {
      return(
        <div id="statsbody">
        <HomeNavbar />
        <div id="statspage">
            <h1>Download</h1>
        <StatsBox title={"Loading download options..."}>
        <SmallLoading />
        </StatsBox>
        </div>
        <Footer /> 
        </div>)  
    }

    function downloadFiles(data, filename, fileNames) {
      console.log("Downloading files:");
      const zip = new JSZip()
            data.forEach((content, index) => {
            zip.file(fileNames[index], content);
            });
            zip.generateAsync({ type: "blob" })
              .then(function(content) {
                const a = document.createElement('a');
                a.href = URL.createObjectURL(content);
                a.download = filename;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              })
              .catch(function(err) {
                console.error("Error creating ZIP file:", err);
              });
    }

    function fetchData(requestOptions, filename){
      if (isDownloading) return;
      setIsDownloading(true);
      let fileNames = []
      let dataToDownload = []
      axios.post("/download", requestOptions)
        .then((response) => {
          const data = response.data;
          console.log("Data received:", data);
          if (requestOptions.reactions) {
            fileNames.push("reactions.csv")
            dataToDownload.push(dataToCsv(data.reactions, data.negatives, data.structures));
          }
          if (requestOptions.mechanisms) {
            
            dataToDownload.push(mechanismDataToCsv(data.mechanisms));
            fileNames.push("mechanisms.csv")
          }
          if (requestOptions.history) {
            dataToDownload.push(persistentIdToCsv(data.persistentId));
            dataToDownload.push(historicNoteToCSV(data.historicNote));
            fileNames.push("persistentId.csv")
            fileNames.push("historicNote.csv")
          }
          if (requestOptions.submission) {
            dataToDownload.push(submissionToCsv(data.submission));
            fileNames.push("submissions.csv")
            dataToDownload.push(submissionToCsv(data.submissionMechanism));
            fileNames.push("submissionsMechanism.csv")
          }
          console.log("Data to download:", dataToDownload);
          downloadFiles(dataToDownload, filename, fileNames);
        })
        .catch((error) => {
          console.error("Error downloading data:", error);
        })
        .finally(() => {
          setIsDownloading(false);
        });
    }

    function wrapTextEvery80Chars(input) {
  return input.replace(/(.{80})/g, '$1\n');
}

    function fetchFasta(){
      if (isDownloading) return;
      setIsDownloading(true);
      axios.post("/download", {reactions: true}).then((response) => {
      let data = response.data;
      let knownEnzymes = [];
      let fastaData = data.reactions.map((reaction) => {
        if (reaction.enzyme_pers_id && !knownEnzymes.includes(reaction.enzyme_pers_id)) {
          knownEnzymes.push(reaction.enzyme_pers_id);
          return `>${reaction.enzyme_pers_id}|${reaction.name}| species=${reaction.species} kingdom=${reaction.kingdom}\n${wrapTextEvery80Chars(reaction.aminoacid_sequence)}`;
        }
        return "";
      }).filter((entry) => entry !== "");
      console.log("Fasta data:", fastaData);
      downloadFiles([fastaData.join("\n\n") ], "MartsDbEnzymesFasta.zip", ["MartsDbEnzymes.fasta"]);
      }).catch((error) => {
          console.error("Error downloading data:", error);
        })
        .finally(() => {
          setIsDownloading(false);
        });
    }

    function convertReactFlowToCytoscape({ nodes, edges }) {
      const getLayoutedElements = (nodes, edges, options) => {
            const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
            g.setGraph({ rankdir: options.direction });
       
            edges.forEach((edge) => g.setEdge(edge.source, edge.target));
            nodes.forEach((node) =>
                    g.setNode(node.id, {
                  ...node,
                  width: 50,
                  height: 50,
                }),
              );
       
            Dagre.layout(g);
       
            return {
              nodes: nodes.map((node) => {
                const position = g.node(node.id);
                // We are shifting the dagre node position (anchor=center center) to the top left
                // so it matches the React Flow node anchor point (top left).
                const x = position.x - (50) / 2;
                const y = position.y - (50) / 2;
              
                return { ...node, position: { x, y } };
              }),
              edges,
            };
          };
          let layouted = getLayoutedElements(nodes, edges, { direction: 'TD' }); 

  const cytoscapeElements = [];

  // Convert nodes
  for (const node of layouted.nodes) {
    const { id, data, position } = node;

    const cytoscapeNode = {
      group: 'nodes',
      data: {
        id,                 
        mol_id: id,         
        chebi: data.chebi,
        marts: data.marts,
        name: data.name,
        type: data.type,
        smiles: data.smiles,
      },
      position: {
        x: position.x,
        y: position.y
      }
    };

    cytoscapeElements.push(cytoscapeNode);
  }

  // Convert edges
  for (const edge of edges) {
    const { id, source, target, data } = edge;

    const cytoscapeEdge = {
      group: 'edges',
      data: {
        id,
        source,
        target,
        ...data
      }
    };

    cytoscapeElements.push(cytoscapeEdge);
  }

  return cytoscapeElements;
}

    function fetchMechanismGraph(){
      if (isDownloading) return;
      setIsDownloading(true);
      axios.post("/getMechNet").then((response) => {
        const data = response.data;
        let res = convertReactFlowToCytoscape(data.data.res_graph);
        downloadFiles([JSON.stringify(res, null, 2)], "MartsDbMechanismGraph.zip", ["MartsDbMechanismGraph.json"]);
      }).catch((error) => {
          console.error("Error downloading data:", error);
        })
        .finally(() => {
          setIsDownloading(false);
        });

      }


    function downloadExistingZip(url, suggestedName) {
    const a = document.createElement("a");
    a.href = url;
    a.download = suggestedName || url.split("/").pop();
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
    

    function fetchStructureZip(filter = {}, labelName) {
      if (isDownloading) return;
      setIsDownloading(true);

      const filterName = labelName || filter.category || (filter.method_id ? `method_${filter.method_id}` : "All");
      const today = new Date().toISOString().split("T")[0];

      axios.get("/downloadstructures", {
        params: filter, // Předáme parametry filtru
        responseType: "blob" 
      })
        .then(resp => {
          const blob = resp.data;
          const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `MartsDB_structures_${filterName}_${today}.zip`;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            a.remove();
        })
        .catch(e => console.error("Download failed", e))
        .finally(() => setIsDownloading(false));
    }

    function downloadSelectedStructures() {
      const source = structureSources.find(s => String(s.source_id) === String(selectedSource));
      if (selectedSource && source) {
        const label = String(source.source_name).trim().replace(/[^\w-]+/g, "_");
        fetchStructureZip({ source_id: source.source_id }, label);
      } else {
        fetchStructureZip({}, "All");
      }
    }

    const totalStructures = structureSources.reduce((sum, s) => sum + Number(s.count || 0), 0);


    const latestNoteDate = new Date(downloadData.latestNoteDate).toISOString()


    return (
      <div id="statsbody">
      <HomeNavbar />
      <div id="basicpage">
      <h1>Download</h1>
      <StatsBox title={`Download latest release: ${latestNoteDate}`} >
      <div className="stats-layout">
        <div className="stats-table">
        <InfoTable data={[["Value", "Enzymes", "Reactions", "Mechanisms"], ["Number of entries"].concat([downloadData.numEnzymes, downloadData.numReactions, downloadData.numMechanisms])]} /> 
        </div>
        <div className="stats-table">
          <div style={{display:"flex", flexDirection:"column", width:"50%", marginLeft:"20px"}}>
          <ResultInfoText text="CSV download" row={1} fontSize="19px" buttonClass="plane-text-button-no-background"/> 
          <DownloadButton onClick={() => (fetchData({reactions:true, mechanisms:true}, `MartsDbReactionsMechanisms_release_${latestNoteDate}.zip`))} text={"Download data"} isDownloading={isDownloading} tooltipText="Download data on mechanisms and reactions in CSV format."/>
          <DownloadButton onClick={() => (fetchData({reactions:true, mechanisms:true, history: true}, `MartsDbWhole_release_${latestNoteDate}.zip`))} text={"Download with history"} isDownloading={isDownloading} tooltipText="Download all the data inside MARTS in CSV format, both data on mechanisms and reactions together with changelog."/>
         </div>
        </div>
        </div>
      </ StatsBox>
      <StatsBox title={"Structures"}>
        <p style={{ margin: "0 0 12px 0" }}>
          Download PDB structure files together with a metadata.csv describing
          each structure's source set. Pick a structure set below, or download every structure at once.
        </p>
        <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
          <select
            value={selectedSource}
            onChange={(e) => setSelectedSource(e.target.value)}
            style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #ccc", minWidth: "320px" }}
          >
            <option value="">All structure sets ({totalStructures} structures)</option>
            {structureSources.map((s) => (
              <option key={s.source_id} value={s.source_id}>
                {s.source_name} ({s.count} {Number(s.count) === 1 ? "structure" : "structures"})
              </option>
            ))}
          </select>
          <DownloadButton
            onClick={downloadSelectedStructures}
            text={"Download structures"}
            isDownloading={isDownloading}
            tooltipText="Download the selected set of PDB structures with metadata.csv in one ZIP."
          />
        </div>
      </StatsBox>
      <StatsBox title={"Other formats"}>
        <InfoTable data={[["Format", "Fasta - enzymes", <><ExternalLink
            idLink={`linkCytoscape`}
            idDiv={`divCytoscape`}
            icon={faExternalLink}
            externalLink={"https://cytoscape.org/"}>
            {"https://cytoscape.org/"}
          </ExternalLink> Cytoscape json - mechanisms</>],
           ["Download"].concat(
            [<DownloadButton onClick={() => (fetchFasta())} text={"Fasta format"} isDownloading={isDownloading} tooltipText="Download all enzymes in MARTS in fasta format."/>,
             <DownloadButton onClick={() => (fetchMechanismGraph())} text={"Cytoscape format"} isDownloading={isDownloading} tooltipText="Download reaction mechanisms in MARTS as a graph that can be displayed using the cytoscape application."/>
            ])]} /> 
      </StatsBox>
     {/* <StatsBox title={"Structures"}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
         <DownloadButton
           onClick={() => fetchStructureZip()}
           text={"All Structures (ZIP)"}
           isDownloading={isDownloading}
           tooltipText="Download all PDB structures with metadata.csv in one ZIP."
         />
         <DownloadButton
           onClick={() => fetchStructureZip({ category: 'Experimental' })}
           text={"Experimental (ZIP)"}
           isDownloading={isDownloading}
           tooltipText="Download all experimentally determined structures (X-ray, Cryo-EM, etc.)."
         />
         <DownloadButton
           onClick={() => fetchStructureZip({ category: 'Predicted' })}
           text={"Predicted (ZIP)"}
           isDownloading={isDownloading}
           tooltipText="Download all predicted structures (AlphaFold, ESMFold)."
         />
       </div>*/}
      {/* <div style={{marginTop: '12px', borderTop: '1px solid #eee', paddingTop: '12px'}}>
         <p style={{margin: '0 0 8px 0', fontSize: '0.9rem', fontWeight: '500'}}>Download by specific method:</p>
         <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            {structureMethods.map(method => (
              <DownloadButton
                key={method.method_id}
                onClick={() => fetchStructureZip({ method_id: method.method_id })}
                text={`${method.method_name} (ZIP)`}
                isDownloading={isDownloading}
                tooltipText={`Download structures determined by ${method.method_name}.`}
              />
            ))}
         </div>
       </div> 
    </StatsBox>*/}

      
      <StatsBox title="Archived versions">
              {isLoadingOlder ? (
            <SmallLoading />
          ) : olderVersions.length === 0 ? (
            <div style={{ padding: "8px 0" }}>No archived versions found.</div>
          ) : (
            (() => {
              // sort newest-looking names first (best-effort if names contain dates)
              const sortedVersions = [...olderVersions].sort((a, b) =>
                b.name.localeCompare(a.name, undefined, { numeric: true })
              );
              const visibleVersions = showAllVersions
                ? sortedVersions
                : sortedVersions.slice(0, 3);
              const hiddenCount = sortedVersions.length - visibleVersions.length;
              return (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxWidth: "480px" }}>
                  {visibleVersions.map(({ name, url }) => (
                    <DownloadButton
                      key={url}
                      onClick={() => downloadExistingZip(url)}
                      text={name}
                      isDownloading={false}
                      tooltipText={`Download ${name}`}
                    />
                  ))}
                  {sortedVersions.length > 3 && (
                    <button
                      className="plane-text-button-no-background"
                      style={{ alignSelf: "flex-start", cursor: "pointer", color: "#173797", fontWeight: "bold" }}
                      onClick={() => setShowAllVersions((prev) => !prev)}
                    >
                      {showAllVersions ? "Show less" : `Show more (${hiddenCount})`}
                    </button>
                  )}
                </div>
              );
            })()
          )}
      </StatsBox>
      {editor.includes(auth?.roles) && (
        <StatsBox title={"Editor options"}>
          <DownloadButton onClick={() => (fetchData({reactions:true, mechanisms:true, history: true, submission: true}, `MartsDbWhole_update_release_${latestNoteDate}.zip`))} text={"Download submissions"} isDownloading={isDownloading}/>
        </StatsBox>
      )}
      </div>
      <Footer />
      </div>)

    }
export default DownloadPage;